import { each } from 'lodash';
import { map } from '../../utils/math';

export default class Controls {

    constructor() {
        this.videos = document.querySelectorAll('.content-hub .tease.video'),

        each(this.videos, (video) => {
            this.controls(video)
        })
    }

    controls(video) {
        var video = {
            element: video.querySelector('video'),
            controls: video.querySelector('.controls'),
            progress: video.querySelector('[data-progress]'),
            seekbar: video.querySelector('[data-progress] span'),
            playpause: video.querySelector('[data-play]'),
        }

        video.controls.setAttribute('data-state', 'visible');
        var supportsProgress = (document.createElement('progress').max !== undefined);

        if (!supportsProgress) { video.progress.setAttribute('data-state', 'fake') }

        const changeButtonState = (type) => {
            if (type == 'playpause') {
                if (video.element.paused || video.element.ended) {
                    video.element.setAttribute('data-state', 'play');
                }
                else {
                    video.element.setAttribute('data-state', 'pause');
                }
            }
        }

        const updateSeekBar = (time) => {
            var currentTime = map(0, video.element.duration, 0, 100);
            video.seekbar.style.width = `${currentTime(time)}%`;
        }

        video.element.addEventListener('play', () => {
            changeButtonState('playpause');
        }, false);

        video.element.addEventListener('pause', () => {
            changeButtonState('playpause');
        }, false);

        video.element.addEventListener('timeupdate', () => {
            updateSeekBar(video.element.currentTime);
        })

        video.playpause.addEventListener('click', (e) => {
            if (video.element.paused || video.element.ended) {
                video.element.play()
            } else {
                video.element.pause()
            }
            video.playpause.classList.toggle('stop');
        });

        // Change current-time
        // video.progress.addEventListener('click', (e) => {
        //     var pos = (e.pageX - (video.progress.offsetLeft + video.progress.offsetParent.offsetLeft)) / video.progress.offsetWidth;
        //     video.element.currentTime = pos * video.element.duration;
        // });
    }
}